export default "__VITE_ASSET__sN2erlf1__"